import { createSlice } from '@reduxjs/toolkit';

const editSessionSlice = createSlice({
  name: 'editSession',
  initialState: {
    currentId: null,
    isBack: false,
  },
  reducers: {
    setEditSession: (state, action) => {
      state.currentId = action.payload;
    },
    clearEditSession: (state) => {
      state.currentId = null;
    },
    setIsBack: (state, action) => {
      state.isBack = action.payload;
    },
  },
});

export const { setEditSession, clearEditSession, setIsBack } =
  editSessionSlice.actions;
export default editSessionSlice.reducer;
